export default function filterIMPCCodesIfExistsInPostalOperators(
  impcCodes,
  postalOperators,
) {
  const filteredIMPCCodes = [];

  if (!postalOperators || postalOperators.length === 0) {
    return [...impcCodes];
  }

  const addIfExistsInIMPCCodes = (impcCode) => {
    if (impcCodes.includes(impcCode)) {
      filteredIMPCCodes.push(impcCode);
    }
  };

  for (let index = 0; index < postalOperators.length; index += 1) {
    const postalOperator = postalOperators[index];

    addIfExistsInIMPCCodes(postalOperator.value);
    for (let impcIndex = 0; impcIndex < postalOperator.children.length; impcIndex += 1) {
      const impc = postalOperator.children[impcIndex];
      addIfExistsInIMPCCodes(impc.value);
    }
  }

  return filteredIMPCCodes;
}
